export function createShareUrl({ text, url }: { text?: string; url?: string }) {
  const p = new URLSearchParams();
  if (text) {
    p.set('text', text);
  }
  if (url) {
    p.set('url', url);
  }
  return `https://twitter.com/intent/tweet?${p.toString()}`;
}
